import React from "react";
import classNames from "classnames";
import styles from "./Job.module.scss";
import topImg from "../../Img/jobPage/default.png";
import JobList from "../../components/JobList/JobList";
export default function Job({
  isDarkMode,
  isSidebar,
  width,
}: {
  isDarkMode: boolean;
  isSidebar: boolean;
  width: number;
}) {
  return (
    <>
      <div className={styles.imgContainer}>
        <img src={topImg} alt="" className={styles.topImg} />
      </div>

      <div className={styles.container}>
        <div
          className={classNames(
            !isDarkMode ? styles.vision : styles.dark_vision
          )}
        >
          <h1
            className={classNames({
              "headline-kr-L": width > 767 ? true : false,
              "headline-kr-M": width < 768 ? true : false,
            })}
          >
            Everyone, MondayOFF
          </h1>
          <div
            className={classNames(styles.vison_context, {
              "label-kr-L": width > 767 ? true : false,
              "body-kr-L": width < 768 ? true : false,
            })}
          >
            <p>
              우리는 전 세계 모든 사람들이 가볍게 접할 수 있는 “짧은 즐거움"을
              개발해요.
            </p>
            <p>
              국가, 나이, 성별에 상관없이 모두에게 즐거움을 줄 수 있도록
              고민하고 또 고민하죠.
            </p>
            <p>
              살아온 환경은 모두 달라도 MondayOFF의 게임 안에서 모두가 웃을 수
              있도록 같이 만들어요.
            </p>
            <p> 더 큰 세계에 즐거움을 전달할 우리와 함께해요.</p>
          </div>
        </div>
        <JobList isDarkMode={isDarkMode} isSidebar={isSidebar} width={width} />
      </div>
    </>
  );
}
